import React, { useState } from "react";
import styles from './styles.module.css';
import { AutoComplete, Button, Container, Row, SearchForm, ViewWithPopup, CountableSet } from "../index";
import { DateRangePicker } from "react-dates";
import 'react-dates/initialize';
import 'react-dates/lib/css/_datepicker.css';
import './react_dates_overrides.css';

import { useHistory } from "react-router-dom";
import * as Icon from "../Icons";
import cn from "classnames";
import * as PATHS from "../../settings/paths";
import { useWindowSize, ResponsiveSize } from '../../utils/useWindowSize';
import { Col } from "react-flexbox-grid";

const tabData = [
	{ name: 'Hotels', icon: <Icon.Hotels /> },
	{ name: 'Transportation', icon: <Icon.FrontOfBus /> },
	{ name: 'Ground Services', icon: <Icon.CustomerSupport /> },
];
const SearchFields = () => {
	const [startDate, setStartDate] = useState();
	const [endDate, setEndDate] = useState();
	const [focusedInput, setFocusedInput] = useState();
	const [activeTab, setActiveTab] = useState(tabData[0].name);
	const router = useHistory();
	const setDates = (startDate, endDate) => {
		setStartDate(startDate);
		setEndDate(endDate);
	};
	const getActiveTabContent = (tab) => {
		switch (tab) {
			case 'Hotels':
				return (
					<Container>
						<div className={styles.text}>
							<b>Find deals on hotels,homes and much more</b>
							<p>From cosy country homes to funky city flats</p>
						</div>
						<SearchForm />
					</Container>
				);
			case 'Transportation':
				return (
					<Container>
						<div className={styles.text}>
							<b>Transportation search</b>
							<p>First find your accommodation</p>
						</div>
						<SearchForm />
					</Container>
				);
			case 'Ground Services':
				return (
					<Container>
						<div className={styles.text}>
							<b>Transportation search</b>
							<p>First find your accommodation</p>
						</div>
						<SearchForm />
					</Container>
				);
			default:
				break;
		}
	};

	const [rooms, setRooms] = useState([
		{
			sequence: 0,
			paxInfo: [{ type: 'ADT', quantity: 2 }],
		},
	]);

	return (
		<div className={styles.main}>
			<div className={styles.flexContainer}>
				<Container>

					<Row>
						<Col lg={4}>
							<div className={styles.input}>
								<p className={styles.inputTitle}>Destination</p>
      
								<AutoComplete placeholder={`City Or Specific Hotels`} />
							</div>
						</Col>
						<Col lg={4}>
							<div className={styles.input}>
								<p className={styles.inputTitle}>Check in - Check Out</p>
								<DateRangePicker 
									verticalHeight={370}
									numberOfMonths={useWindowSize().width <= ResponsiveSize.MD ? 1 : 2}
									showDefaultInputIcon={true}
									inputIconPosition={"after"}
									noBorder
									block
									startDatePlaceholderText={'Check In'}
									endDatePlaceholderText={'Check Out'}
									startDateId={'startDate'}
									endDateId={'endDate'}
									startDate={startDate}
									endDate={endDate}
									onDatesChange={({ startDate, endDate }) => {
										setDates(startDate, endDate);
									}}
									focusedInput={focusedInput}
									onFocusChange={(focusedInput) => {
										setFocusedInput(focusedInput);
									}}
								/>
							</div>
						</Col>
						<Col lg={3}>
							<div className={styles.input}>
								<p className={styles.inputTitle}>Room & Guests</p>
								<ViewWithPopup
									key={200}
									noView={true}
									style={{ width: '100%' }}
									view={
										<Button icon={<Icon.Guests/>} style={{ backgroundColor: 'white', width: '100%', color: '#757575', paddingTop:"1rem" }}>Adult-Children-Room</Button>
									}
									popup={<CountableSet rooms={rooms} setRooms={setRooms} />}
								/>
							</div>
						</Col>
						<Col lg={1}>
							<div className={styles.buttonAligner}>
								<p style={{marginBottom:"1rem"}}>a</p>
								<Button onClick={() => router.push(PATHS.SEARCH_RESULTS)}>{'Search'}</Button>
							</div>
						</Col>
					</Row>
				</Container>
			</div>
			<div className={styles.tabsContainer}>
				<div className={styles.searchTabs}>
					<Container>
						<ul className={styles.tabs}>
							{tabData.map((tab, index) => (
								<li key={index} className={cn([styles.tabsItem, tab.name === activeTab && styles.activeTab])}>
									<button onClick={() => setActiveTab(tab.name)}>
										{tab.icon}
										{tab.name}
									</button>
								</li>
							))}
							<li className={cn([styles.tabsItem])}>
								<button onClick={() => router.push(PATHS.B2B_LOGIN)}>
									<Icon.B2Bservices />
									Umrah B2B Services
								</button>
							</li>
						</ul>
					</Container>
				</div>
			</div>

		</div>

	)
};
export default SearchFields